import { useState } from "react";
import { Grid } from "@mui/material";

import { useQuery } from "@tanstack/react-query";
import StickyHeadTable from "ui-components/tables/StickyTable";
import TimelineList from "ui-components/Timeline/TimelineList";
import TimelineItem from "ui-components/Timeline/TimelineItem";
import { getSKUKitLog } from "services/data.internal.service";
import Drawer from "ui-components/Drawer";

const columns = [
  { label: "SKU Code", id: "skuCode" },
  { label: "Description", id: "skuDescription" },
  { label: "Quantity", id: "quantity" },
  { label: "CreatedOn", id: "createdOn" },
];

function SKUKitLog({ open, setOpen, logRequest, setLogRequest }) {
  //const onError = (data) => setAlert(<Error data={data} onChange={setAlert} />);

  const [logs, setLogs] = useState(null);

  useQuery({
    queryKey: ["sku-kit-log", { logRequest }],
    queryFn: () => getSKUKitLog(logRequest),
    enabled: logRequest !== null,
    onSuccess: (data) => {
      const item = data.data.data;
      console.log(item.logs);

      const renderTimelineItems = item.logs.map(({ id, ...log }) => (
        <TimelineItem key={id} {...log} />
      ));
      setLogs(
        <>
          <div style={{ fontSize: "14px", marginBottom: "20px" }}>
            <Grid container>
              <Grid item xs={6}>
                <b>Kit SKU : </b>
                {item.kitSKU}
              </Grid>
              <Grid item xs={6}>
                <b>Kit Name : </b>
                {item.kitName}
              </Grid>
              <Grid item xs={6}>
                <b>Selling Price : </b>
                {item.sellingPrice}
              </Grid>
            </Grid>
          </div>
          <div>
            <StickyHeadTable columns={columns} rows={item.details} />
          </div>
          <TimelineList title="Logs">{renderTimelineItems}</TimelineList>
        </>
      );
      //setPonum(null);
    },
    //onError,
  });

  const toggleDrawer = (open) => (event) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }
    setOpen(open);
    setLogs(null);
    setLogRequest(null);
  };

  return (
    <Drawer open={open} onClose={toggleDrawer(false)} onOpen={toggleDrawer(true)}>
      {logs}
    </Drawer>
  );
}

export default SKUKitLog;
